<app-header-content-help-text [Heading]="'Parameters Locations'" [helpText]="'Configure Attributes for Warehouse Information'"></app-header-content-help-text>

<app-parameter-table-molecule [fuctionality]="'locations'"></app-parameter-table-molecule>
